import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';
import { ROOT_ROUTES } from './router.config';

export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.idp_url,
  clientId: environment.client_id,
  redirectUri: `${window.location.origin}/${ROOT_ROUTES.signIn}`,
  responseType: 'code',
  useSilentRefresh: true,
  postLogoutRedirectUri: window.location.origin,
  silentRefreshRedirectUri: `${window.location.origin}/assets/silent-callback.html`,
  scope: 'openid profile api-lhapi sites.manage scorecards.manage conversations agentcall.manage acevla.manage',
  showDebugInformation: environment.show_auth_debug_information,
  sessionCheckIntervall: 10000,
  timeoutFactor: 0.9,
  sessionChecksEnabled: true,
};

export const loginStatusKey = 'loginStatus';

export enum ELoggedInStatus {
  LoggedIn = 'LoggedIn',
  LoggedOut = 'LoggedOut',
}
